export interface Salary_Sanavat_Interface {
    id:number,
    year:number,
    day:number,
    sanavat:number,
}


export function Empty_Salary_Sanavat_Interface():Salary_Sanavat_Interface{
  return{
    id:0,
    year:0,
    day:0,
    sanavat:0,
  }
}